import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的自选职业推送ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  title: [
    {...makeRule('请输入自选职业推送名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
  detail: [
    {...makeRule('请输入推送文案', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
  cycle: [
    {...makeRule('请选择推送开始/结束时间', 'array')},
  ],
  occupations: [
    {...makeRule('请选择职业', 'array')},
  ]
}

export let occupationRules = {
  id: [
    {...makeRule('请选择自选职业推送', 'integer')},
    {...makeRule('请选择自选职业推送', 'integer', 'change')}
  ]
}



// WEBPACK FOOTER //
// ./src/views/occupation-questionnaire/occupation-questionnaire.rules.js